module.exports = __webpack_public_path__ + "static/media/onboardinstep1.4d768448.svg";